import axios from "axios"
import AccidentUpsellData from './AccidentUpsellData';

export default function(start_date, email, phone, insurance_amount) {
    return { 
        // The page sets accident_endpoint when the add-on is enabled.
        ...AccidentUpsellData(),

        loading: false,
        errors: {},
        price: '...',
        price_loading: true,
        start_date: '',
        payment_method: 'focus',
        payment_interval: '12',
        email: '',
        phone: '',
        accept_terms: false,
        show_price: false,
        submit_error: null,
        insurance_amount: 0,

        // New summary design state
        summary_open: false,
        details_open: false,

        init() {
            this.bankid.init();

            this.start_date = start_date;
            this.email = email;
            this.phone = phone;
            this.insurance_amount = insurance_amount;

            if (!email || !phone) {
                this.details_open = true;
            }

            this.setupWatchers();
            this.updatePrice();
            this.initAccidentUpsell();

            this.$watch(() => this.bankid.status_message, status => {
                if (status === 'ERROR') {
                    this.bankid.cancel();
                    this.submit_error = true;
                }
            });

            if (this.datalayer) {
                let datalayer_object = JSON.parse(JSON.stringify(this.datalayer));
                dataLayer.push(datalayer_object);
            }
        },

        save() {
            this.loading = true;

            axios.post('/step/sadelforsakring-anpassa/save', {
                start_date: this.start_date,
                payment_interval: this.payment_interval,
                payment_method: this.payment_method,
                email: this.email,
                phone: this.phone,
                accept_terms: this.accept_terms,
                accident_insurance: this.accident_insurance
            }).then((response) => {
                this.loading = false;
                
                if (response.data.redirect) {
                    window.location.href = response.data.redirect;
                    return;
                }

                return this.bankid.sign(
                    '/step/sadelforsakring-anpassa/bankid_sign',
                    '/step/sadelforsakring-anpassa/bankid_cancel',
                    '/step/sadelforsakring-anpassa/bankid_status'
                ).catch(error => {
                    this.bankid.cancel();

                    if (error.response.status, error.response.data.errors['submit_error']) {
                        this.submit_error = error.response.data.errors['submit_error'];

                        this.bankid.cancel();
                    }
                });
            }).catch((error) => {
                this.errors = error.response.data.errors;

                this.loading = false;

                if (Object.keys(this.errors).length > 0) {
                    this.details_open = true;

                    setTimeout(() => {
                        window.scrollto.selector('[name='+ Object.keys(this.errors)[0] +']', 120);
                    }, 250);
                }
            });
        },

        updatePrice() {
            // Flag loading immediately (outside the debounce) so the "Räknar ut pris..."
            // indicator shows the moment the period changes, matching the pet flows.
            this.price_loading = true;

            clearTimeout(this.updatePriceTimout);
            this.updatePriceTimout = setTimeout(() => {
                this.errors = [];
                this.loading = true;

                axios.post('/step/sadelforsakring-anpassa/price', {
                    start_date: this.start_date,
                    payment_interval: this.payment_interval,
                    email: this.email,
                    phone: this.phone
                }).then((response) => {
                    this.price = response.data.price;
                    this.loading = false;
                }).catch((error) => {
                    this.price = 0;
                    this.loading = false;

                    for (let key in error.response.data.errors) {
                        this.errors[key] = error.response.data.errors[key];
                    }

                    if (error.response.status === 419) {
                        window.location.reload();
                    }
                }).finally(() => {
                    this.price_loading = false;
                });
            }, 250);
        },

        intervalSuffix() {
            return {
                '1': 'mån',
                '3': 'kvartal',
                '12': 'år',
            }[this.payment_interval] || 'år';
        },

        setupWatchers() {
            this.$watch(() => [this.start_date, this.payment_interval, this.email, this.phone], (value) => {
                this.updatePrice();
            });
        }
    }
}